module.exports = __webpack_public_path__ + "img/13.ec5b4519.png";